var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderVue'),(_vm.horizontal == 'true')?_c('div',{staticClass:"default-box-h"},[_c('div',{staticClass:"default-l"},[_c('router-view')],1),_c('div',{staticClass:"default-r"},[_c('NavVue')],1)]):_c('div',[_c('div',{staticClass:"default-box-v"},[_c('router-view')],1),_c('NavVue')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }